import React, { PropsWithChildren } from 'react'
import {
  Card as MUICard,
  CardProps,
  CardActionArea,
  CardActionAreaProps,
  CardContent,
  CardContentProps,
  CardHeader,
  CardHeaderProps,
  CardMedia,
  CardMediaProps,
} from '@mui/material'

const Card: React.FC<PropsWithChildren & CardProps> = ({
  children,
  ...props
}) => (
  <MUICard variant='outlined' {...props}>
    {children}
  </MUICard>
)

export { Card, CardActionArea, CardContent, CardHeader, CardMedia }

export type {
  CardProps,
  CardActionAreaProps,
  CardContentProps,
  CardHeaderProps,
  CardMediaProps,
}
